import React, { useState, useEffect, useRef } from 'react';
import examsService from '../services/examsService';
import './Colleges.css'; // Reuse Colleges.css styling

// Exhaustive list of all countries (same as Books.js and Colleges.js)
const ALL_COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina',
  'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana',
  'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon',
  'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo',
  'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica',
  'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea',
  'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia',
  'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
  'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania',
  'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
  'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua',
  'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine',
  'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar',
  'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

// Icon Components
const PlusIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M6 12H12M18 12H12M12 12V6M12 12V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const EditIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M3 21L12 21H21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M12.2218 5.82839L15.0503 2.99996L20 7.94971L17.1716 10.7781M12.2218 5.82839L6.61522 11.435C6.42769 11.6225 6.32233 11.8769 6.32233 12.1421L6.32233 16.6776L10.8579 16.6776C11.1231 16.6776 11.3774 16.5723 11.565 16.3847L17.1716 10.7781M12.2218 5.82839L17.1716 10.7781" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const DeleteIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M8.99219 13H11.9922H14.9922" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M3.03919 4.2939C3.01449 4.10866 3.0791 3.92338 3.23133 3.81499C3.9272 3.31953 6.3142 2 12 2C17.6858 2 20.0728 3.31952 20.7687 3.81499C20.9209 3.92338 20.9855 4.10866 20.9608 4.2939L19.2616 17.0378C19.0968 18.2744 18.3644 19.3632 17.2813 19.9821L16.9614 20.1649C13.8871 21.9217 10.1129 21.9217 7.03861 20.1649L6.71873 19.9821C5.6356 19.3632 4.90325 18.2744 4.73838 17.0378L3.03919 4.2939Z" stroke="currentColor" strokeWidth="1.4"></path>
    <path d="M3 5C5.57143 7.66666 18.4286 7.66662 21 5" stroke="currentColor" strokeWidth="1.4"></path>
  </svg>
);

const CloseIcon = () => (
  <svg width="14px" height="14px" strokeWidth="2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const Exams = () => {
  const [exams, setExams] = useState([]);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCountry, setFilterCountry] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Drawer states
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState('add'); // 'add' or 'edit'
  const [currentEditId, setCurrentEditId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    countries: [],
    status: 'active',
    metadata: ''
  });

  // Country autocomplete states (multi-select)
  const [countriesSearchTerm, setCountriesSearchTerm] = useState('');
  const [showCountriesSuggestions, setShowCountriesSuggestions] = useState(false);
  const countriesAutocompleteRef = useRef(null);

  // Delete modal states
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1); // Reset to first page on search
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Handle click outside for autocomplete
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countriesAutocompleteRef.current && !countriesAutocompleteRef.current.contains(event.target)) {
        setShowCountriesSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fetch exams from API
  useEffect(() => {
    fetchExams();
  }, [currentPage, itemsPerPage, filterStatus, filterCountry, debouncedSearchTerm]);

  const fetchExams = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = {
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        status: filterStatus,
        country: filterCountry
      };

      const response = await examsService.getAll(params);

      setExams(response.data.map(exam => ({ ...exam, selected: false })));
      setTotalPages(response.pagination.totalPages);
      setTotalItems(response.pagination.total);
      setCurrentPage(response.pagination.page);

    } catch (err) {
      console.error('Error fetching exams:', err);
      setError('Failed to load exams. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const exam = exams.find(e => e.id === id);
      const newStatus = exam.status === 'active' ? 'inactive' : 'active';

      await examsService.update(id, {
        name: exam.name,
        countries: exam.countries,
        status: newStatus
      });

      // Update local state
      setExams(exams.map(e =>
        e.id === id ? { ...e, status: newStatus } : e
      ));

    } catch (err) {
      console.error('Error updating status:', err);
      alert('Failed to update status. Please try again.');
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setExams(exams.map(exam => ({ ...exam, selected: newSelectAll })));
  };

  const handleSelectOne = (id) => {
    setExams(exams.map(exam =>
      exam.id === id ? { ...exam, selected: !exam.selected } : exam
    ));
  };

  const handleEdit = (id) => {
    const exam = exams.find(e => e.id === id);
    if (exam) {
      let countriesArray = [];
      try {
        if (exam.countries) {
          countriesArray = typeof exam.countries === 'string' ? JSON.parse(exam.countries) : exam.countries;
        }
      } catch (e) {
        countriesArray = [];
      }

      setFormData({
        name: exam.name,
        countries: countriesArray || [],
        status: exam.status,
        metadata: exam.metadata ? (typeof exam.metadata === 'string' ? exam.metadata : JSON.stringify(exam.metadata, null, 2)) : ''
      });
      setCurrentEditId(id);
      setDrawerMode('edit');
      setIsDrawerOpen(true);
    }
  };

  const handleDelete = (id) => {
    setDeleteTargetId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await examsService.delete(deleteTargetId);

      // Update local state
      setExams(exams.filter(e => e.id !== deleteTargetId));
      setTotalItems(totalItems - 1);
      setIsDeleteModalOpen(false);
      setDeleteTargetId(null);

    } catch (err) {
      console.error('Error deleting exam:', err);
      if (err.response?.data?.message) {
        alert(err.response.data.message);
      } else {
        alert('Failed to delete exam. Please try again.');
      }
      setIsDeleteModalOpen(false);
      setDeleteTargetId(null);
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
    setDeleteTargetId(null);
  };

  const handleAddNew = () => {
    setFormData({ name: '', countries: [], status: 'active', metadata: '' });
    setDrawerMode('add');
    setCurrentEditId(null);
    setCountriesSearchTerm('');
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setFormData({ name: '', countries: [], status: 'active', metadata: '' });
    setCurrentEditId(null);
    setCountriesSearchTerm('');
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = {
        name: formData.name,
        countries: formData.countries.length > 0 ? formData.countries : null,
        status: formData.status,
        metadata: formData.metadata ? (formData.metadata.trim() ? formData.metadata : null) : null
      };

      if (drawerMode === 'add') {
        const response = await examsService.create(submitData);

        // Add to local state
        setExams([{ ...response.data, selected: false }, ...exams]);
        setTotalItems(totalItems + 1);

      } else {
        const response = await examsService.update(currentEditId, submitData);

        // Update local state
        setExams(exams.map(e =>
          e.id === currentEditId ? { ...response.data, selected: false } : e
        ));
      }

      handleCloseDrawer();

    } catch (err) {
      console.error('Error saving exam:', err);
      if (err.response?.data?.message) {
        alert(err.response.data.message);
      } else {
        alert('Failed to save exam. Please try again.');
      }
    }
  };

  const handleFormStatusToggle = () => {
    setFormData({
      ...formData,
      status: formData.status === 'active' ? 'inactive' : 'active'
    });
  };

  // Country autocomplete functions (multi-select)
  const getFilteredCountries = () => {
    if (!countriesSearchTerm.trim()) return ALL_COUNTRIES.slice(0, 10);
    return ALL_COUNTRIES.filter(country =>
      !formData.countries.includes(country) &&
      country.toLowerCase().includes(countriesSearchTerm.toLowerCase())
    ).slice(0, 10);
  };

  const handleAddCountry = (country) => {
    if (!formData.countries.includes(country)) {
      setFormData(prev => ({
        ...prev,
        countries: [...prev.countries, country]
      }));
    }
    setCountriesSearchTerm('');
    setShowCountriesSuggestions(false);
  };

  const handleRemoveCountry = (country) => {
    setFormData(prev => ({
      ...prev,
      countries: prev.countries.filter(c => c !== country)
    }));
  };

  // Format countries for display
  const formatCountries = (countries) => {
    if (!countries) return 'Global';
    try {
      const countriesArray = typeof countries === 'string' ? JSON.parse(countries) : countries;
      if (Array.isArray(countriesArray) && countriesArray.length > 0) {
        return countriesArray.length > 2 
          ? `${countriesArray.slice(0, 2).join(', ')} +${countriesArray.length - 2} more`
          : countriesArray.join(', ');
      }
    } catch (e) {
      return 'Global';
    }
    return 'Global';
  };

  return (
    <div className="colleges-container">
      <div className="colleges-header">
        <div className="header-left">
          <h1 className="page-title">Exams</h1>
          <p className="page-description">Manage medical exams for the platform</p>
        </div>
        <div className="header-right">
          <select
            className="filter-select"
            value={filterStatus}
            onChange={(e) => {
              setFilterStatus(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
          <select
            className="filter-select"
            value={filterCountry}
            onChange={(e) => {
              setFilterCountry(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Countries</option>
            {ALL_COUNTRIES.map(country => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
          <button className="add-btn" onClick={handleAddNew}>
            <PlusIcon />
            <span>Add Exam</span>
          </button>
        </div>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search exams..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="colleges-table">
          <thead>
            <tr>
              <th className="checkbox-col">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="checkbox"
                />
              </th>
              <th className="college-col">Exam Name</th>
              <th className="country-col">Countries</th>
              <th className="status-col">Status</th>
              <th className="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="loading-state">
                  Loading exams...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="5" className="error-state">
                  {error}
                </td>
              </tr>
            ) : exams.length > 0 ? (
              exams.map((exam) => (
                <tr key={exam.id}>
                  <td className="checkbox-col">
                    <input
                      type="checkbox"
                      checked={exam.selected}
                      onChange={() => handleSelectOne(exam.id)}
                      className="checkbox"
                    />
                  </td>
                  <td className="college-col">
                    <span className="college-name">{exam.name}</span>
                  </td>
                  <td className="country-col">
                    <span className="country-name">{formatCountries(exam.countries)}</span>
                  </td>
                  <td className="status-col">
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={exam.status === 'active'}
                        onChange={() => handleToggleStatus(exam.id)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                    <span className={`status-badge ${exam.status}`}>
                      {exam.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="actions-col">
                    <div className="action-buttons">
                      <button
                        className="action-btn edit-btn"
                        onClick={() => handleEdit(exam.id)}
                        title="Edit"
                      >
                        <EditIcon />
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={() => handleDelete(exam.id)}
                        title="Delete"
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">
                  No exams found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {!loading && !error && totalItems > 0 && (
        <div className="pagination">
          <div className="pagination-left">
            <span className="pagination-label">Show</span>
            <select
              className="pagination-select"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span className="pagination-label">entries</span>
          </div>
          <div className="pagination-center">
            <span className="pagination-info">
              Page {currentPage} of {totalPages} ({totalItems} total)
            </span>
          </div>
          <div className="pagination-right">
            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Drawer */}
      <div className={`drawer-overlay ${isDrawerOpen ? 'open' : ''}`} onClick={handleCloseDrawer}></div>
      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2 className="drawer-title">
            {drawerMode === 'add' ? 'Add New Exam' : 'Edit Exam'}
          </h2>
          <button className="drawer-close" onClick={handleCloseDrawer}>
            <svg width="24px" height="24px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
              <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </button>
        </div>

        <form onSubmit={handleFormSubmit} className="drawer-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label">Exam Name *</label>
            <input
              type="text"
              id="name"
              className="form-input"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Enter exam name"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Applicable Countries (Optional)</label>
            <div className="autocomplete-container" ref={countriesAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={countriesSearchTerm}
                onChange={(e) => {
                  setCountriesSearchTerm(e.target.value);
                  setShowCountriesSuggestions(true);
                }}
                onFocus={() => setShowCountriesSuggestions(true)}
                placeholder="Type to search countries..."
              />

              {showCountriesSuggestions && getFilteredCountries().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredCountries().map((country) => (
                    <div
                      key={country}
                      className="suggestion-item"
                      onClick={() => handleAddCountry(country)}
                    >
                      {country}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.countries.length > 0 && (
              <div className="selected-items" style={{ marginTop: '12px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {formData.countries.map((country) => (
                  <div key={country} className="selected-item-card" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', backgroundColor: '#fafcfdff', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' }}>
                    <span className="selected-item-name">{country}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveCountry(country)}
                      title="Remove"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
            <small className="form-hint">Leave empty if applicable globally.</small>
          </div>

          <div className="form-group">
            <label className="form-label">Status</label>
            <div className="status-toggle-group">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={formData.status === 'active'}
                  onChange={handleFormStatusToggle}
                />
                <span className="toggle-slider"></span>
              </label>
              <span className={`status-badge ${formData.status}`}>
                {formData.status === 'active' ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="metadata" className="form-label">Metadata (JSON)</label>
            <textarea
              id="metadata"
              className="form-textarea"
              value={formData.metadata}
              onChange={(e) => setFormData({ ...formData, metadata: e.target.value })}
              placeholder='{"key": "value"}'
              rows={4}
            />
            <small className="form-hint">Optional: Enter JSON metadata for additional information</small>
          </div>

          <div className="drawer-actions">
            <button type="button" className="btn-cancel" onClick={handleCloseDrawer}>
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              {drawerMode === 'add' ? 'Add Exam' : 'Update Exam'}
            </button>
          </div>
        </form>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <>
          <div className="modal-overlay" onClick={handleCancelDelete}></div>
          <div className="delete-modal">
            <div className="modal-icon">
              <svg width="48px" height="48px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#F07167">
                <path d="M8.99219 13H11.9922H14.9922" stroke="#F07167" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M3.03919 4.2939C3.01449 4.10866 3.0791 3.92338 3.23133 3.81499C3.9272 3.31953 6.3142 2 12 2C17.6858 2 20.0728 3.31952 20.7687 3.81499C20.9209 3.92338 20.9855 4.10866 20.9608 4.2939L19.2616 17.0378C19.0968 18.2744 18.3644 19.3632 17.2813 19.9821L16.9614 20.1649C13.8871 21.9217 10.1129 21.9217 7.03861 20.1649L6.71873 19.9821C5.6356 19.3632 4.90325 18.2744 4.73838 17.0378L3.03919 4.2939Z" stroke="#F07167" strokeWidth="1.4"></path>
                <path d="M3 5C5.57143 7.66666 18.4286 7.66662 21 5" stroke="#F07167" strokeWidth="1.4"></path>
              </svg>
            </div>
            <h3 className="modal-title">Delete Exam</h3>
            <p className="modal-message">
              Are you sure you want to delete "{exams.find(e => e.id === deleteTargetId)?.name}"? This action cannot be undone.
            </p>
            <div className="modal-actions">
              <button className="modal-btn modal-btn-cancel" onClick={handleCancelDelete}>
                Cancel
              </button>
              <button className="modal-btn modal-btn-delete" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Exams;

